import React from 'react';
import { StyleSheet } from 'react-native';
import { useStyle } from 'react-native-style-utilities';
import { BodyText, theme } from '@sg/garnish';

export const HomeInfoText = (props: HomeInfoTextProps) => {
  const textStyles = useStyle(
    () => ({ color: props.fontColor }),
    [props.fontColor],
  );

  return (
    <BodyText sizeMatch={['12']} style={[styles.infoText, textStyles]}>
      {props.text}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  infoText: {
    marginTop: -theme.spacing['1'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type HomeInfoTextProps = {
  text: string;
  fontColor: string;
};
